window._setCookie = function (name, value, days, path) {
  var expires = '';
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 86400000)); // 1 day in seconds
      expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; SameSite=Strict; path=' + (path || '/');
}

window._getCookie = function (name) {
  var nameEQ = name + '=';
  var cookie = document.cookie.split(';').find(function(c) {
    return c.replace(/^ +/, '').indexOf(nameEQ) === 0;
  });
  return (cookie && cookie.substring(nameEQ.length + 1)) || null;
}

window._eraseCookie = function (name) {
  document.cookie = name+'=; Max-Age=-99999999;';
}